


// import React, { useState } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import toast from "react-hot-toast";
// import { login as reduxLogin, getMyPermissions } from "../redux/actions/authActions";
// import { useAuth } from "../context/AuthContext";
// import LogoImg from "../images/images.png";

// const Login = () => {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { login } = useAuth(); // From AuthContext

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (loading) return;
//     setLoading(true);

//     try {
//       const response = await dispatch(reduxLogin(username, password));

//       if (response?.meta?.status) {
//         const {
//           access_token,
//           id,
//           username: name,
//           phone,
//           role,
//           municipality,
//           district,
//         } = response.data;

//         // ✅ Save only what’s needed manually (optional, AuthContext handles token & role)
//         localStorage.setItem("userId", id);
//         localStorage.setItem("name", name);
//         localStorage.setItem("phone", phone);
//         localStorage.setItem("municipality", municipality);
//         localStorage.setItem("district", district);

//         // ✅ Call login from context to set token + role
//         login(access_token, role);

//         // ✅ Get permissions from Redux
//         await dispatch(getMyPermissions());

//         toast.success("Login successful");

//         // ✅ Navigate to dashboard
//         navigate("/dashboard");
//       } else {
//         toast.error(response?.meta?.message || "Invalid credentials.");
//       }
//     } catch (err) {
//       toast.error(err.message || "Login error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="flex h-screen">
//       <div className="w-1/2 flex flex-col justify-center items-center bg-white">
//         <img className="w-[20%] mb-4" src={LogoImg} alt="Logo" />
//         <div className="text-center text-black">
//           <h1 className="text-lg font-semibold">State Urban Development Agency (SUDA)</h1>
//           <h2 className="text-base">Urban Development & Municipal Affairs Department</h2>
//           <h3 className="text-base">Govt. of West Bengal</h3>
//         </div>
//       </div>

//       <div className="w-1/2 flex flex-col gap-4 justify-center items-center bg-gray-200">
//         <h1 className="text-2xl font-bold">Sign in</h1>
//         <form
//           className="bg-white w-[80%] p-8 flex flex-col gap-4 rounded-2xl"
//           onSubmit={handleSubmit}
//         >
//           <input
//             className="py-2 px-2 bg-gray-200 rounded-lg"
//             placeholder="Username or Phone"
//             value={username}
//             onChange={(e) => setUsername(e.target.value)}
//             required
//           />
//           <input
//             className="py-2 px-2 bg-gray-200 rounded-lg"
//             placeholder="Password"
//             type="password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             required
//           />
//           <button type="submit" className="bg-black text-white p-2 rounded-md" disabled={loading}>
//             {loading ? "Logging in..." : "Submit"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {
  login as reduxLogin,
  getMyPermissions,
} from "../redux/actions/authActions";
import { useAuth } from "../context/AuthContext";
import { requestForToken } from "../firebase";
import LogoImg from "../images/National-Emblem.png";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [fcmToken, setFcmToken] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { login } = useAuth(); // AuthContext

  // 🔥 Fetch FCM token on page load
  useEffect(() => {
    const getToken = async () => {
      try {
        const token = await requestForToken();
        if (token) setFcmToken(token);
      } catch (err) {
        console.error("FCM Token Error:", err);
      }
    };
    getToken();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    try {
      // 🔥 pass FCM token into reduxLogin
      const response = await dispatch(reduxLogin(username, password, fcmToken));

      if (response?.meta?.status) {
        const {
          access_token,
          id,
          username: name,
          phone,
          role,
          municipality,
          district,
        } = response.data;

        // Save essential info
        localStorage.setItem("userId", id);
        localStorage.setItem("name", name);
        localStorage.setItem("phone", phone);
        localStorage.setItem("municipality", municipality);
        localStorage.setItem("district", district);

        // AuthContext login
        login(access_token, role);

        // Fetch permissions
        await dispatch(getMyPermissions());

        toast.success("Login successful");

        navigate("/dashboard");
      } else {
        toast.error(response?.meta?.message || "Invalid credentials.");
      }
    } catch (err) {
      toast.error(err.message || "Login error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-screen">
      {/* Left Section */}
      <div className="w-1/2 flex flex-col justify-center items-center bg-white">
        <img className="w-[20%] mb-4" src={LogoImg} alt="Logo" />
        <div className="text-center text-black">
          <h1 className="text-lg font-semibold">
            State Urban Development Agency (SUDA)
          </h1>
          <h2 className="text-base">
            Urban Development & Municipal Affairs Department
          </h2>
          <h3 className="text-base">Govt. of West Bengal</h3>
        </div>
      </div>

      {/* Right Section */}
      <div className="w-1/2 flex flex-col gap-4 justify-center items-center bg-gray-200">
        <h1 className="text-2xl font-bold">Sign in</h1>

        <form
          className="bg-white w-[80%] p-8 flex flex-col gap-4 rounded-2xl"
          onSubmit={handleSubmit}
        >
          <input
            className="py-2 px-2 bg-gray-200 rounded-lg"
            placeholder="Username or Phone"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <input
            className="py-2 px-2 bg-gray-200 rounded-lg"
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button
            type="submit"
            className="bg-black text-white p-2 rounded-md"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
